import { render, staticRenderFns } from "./LayoutCenter0.vue?vue&type=template&id=08c7dafc"
import script from "./LayoutCenter0.vue?vue&type=script&lang=js"
export * from "./LayoutCenter0.vue?vue&type=script&lang=js"
import style0 from "./LayoutCenter0.vue?vue&type=style&index=0&id=08c7dafc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports